import { useSelector } from "react-redux";

const useDeploymentScheduler = () => {
  const deploymentScheduler = useSelector((state) => state.deploymentScheduler);
  const { deploymentDetailsData } = deploymentScheduler.deploymentDetails;
  const { addDeploymentScheduleData } = deploymentScheduler.addDeploymentSchedule;
  const { updateDeploymentScheduleData } =
    deploymentScheduler.updateDeploymentSchedule;
  const { deleteDeploymentScheduleData } =
    deploymentScheduler.deleteDeploymentSchedule;
  return {
    deploymentDetailsData,
    addDeploymentScheduleData,
    updateDeploymentScheduleData,
    deleteDeploymentScheduleData,
  };
};

export default useDeploymentScheduler;
